<template>
  <div class="w-100">
    <div class="overlay" :class="add_csv_modal ? 'open' : ''" @click="closeCreateReport()"></div>
    <div class="pr-detail-modal" :class="add_csv_modal ? 'open' : ''">
      <div class="request-pr-wrap">
        <div class="request-pr-title" style="font-size: 16px">
          <!-- <div class="header-sns instagram"><font-awesome-icon :icon="['fab', 'instagram']" /></div> -->
          エクセル/CSVから投稿を追加
        </div>
        <div class="request-pr-step">
          <el-steps :active="create_page-1" align-center style="padding:0 20px">
            <el-step description="ファイルアップロード" @click.native="create_page = 2"></el-step>
            <el-step description="内容確認" @click.native="create_page = 3"></el-step>
          </el-steps>
        </div>
        <div class="request-pr-form">
          <reportCreateUpload :create_page.sync="create_page" :create_type="'manual'" :parent_component="'report_detail'" :report="report" @closeDrawer="closeCreateReport()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportCreateUpload from "./report_create_upload";

export default {
  name: "reportAddDrawer",
  components: {
    reportCreateUpload,
  },
  props: ["add_csv_modal", "report_id"],
  data() {
    return {
      create_page: 2,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission.report;
    },
    activate() {
      return this.$store.state.activate;
    },
    report(){
      let report = {report_id: this.report_id}
      return report;
    }
  },
  mounted() {},
  methods: {
    closeCreateReport() {
      this.$emit("closeCreateReport");
      document.documentElement.style.overflow = "auto";
    },
    createReportPageBack() {
      this.create_page -= 1;
    },
    createReportPageNext() {
      this.create_page += 1;
    },
  },
  watch: {
  },
  filters: {
  },
};
</script>
